import { useEffect } from 'react';
import { MdClose, MdDownload } from 'react-icons/md';
import { useStrings } from '../i18n/useStrings';
import { handleFileDownload } from '../helpers/fileUtils';
import './image-lightbox.css';

/**
 * Image lightbox component
 * Displays image in fullscreen overlay when clicked
 * 
 * @param {string} imageUrl - URL of the image to display
 * @param {string} imageName - Name of the image file
 * @param {Function} onClose - Callback when lightbox is closed
 */
export default function ImageLightbox({ imageUrl, imageName, onClose }) {
    const strings = useStrings();

    // Close on Escape key
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    // Handle download
    const handleDownload = (e) => {
        e.stopPropagation();
        handleFileDownload(imageUrl, imageName);
    };

    return (
        <div className="imageLightbox" onClick={onClose}>
            <div className="imageLightboxHeader">
                <span className="imageLightboxTitle">{imageName}</span>
                <div className="imageLightboxActions">
                    <button 
                        className="imageLightboxButton"
                        onClick={handleDownload}
                        title={strings.download}
                    >
                        <MdDownload size={24} />
                    </button>
                    <button 
                        className="imageLightboxButton"
                        onClick={onClose}
                        title={strings.close || 'Close'}
                    >
                        <MdClose size={24} />
                    </button>
                </div>
            </div>
            <div className="imageLightboxContent" onClick={(e) => e.stopPropagation()}>
                <img 
                    src={imageUrl} 
                    alt={imageName}
                    className="imageLightboxImage"
                />
            </div>
        </div>
    );
}
